// src/api/axiosInstance.js
import axios from "axios";
import store from "../store";
import { startLoading, stopLoading } from "../store/loadingSlice";
import { resetUser, logout } from "../store/userSlice";
import { goLogin } from "../utils/navigation";

const axiosInstance = axios.create({
  baseURL: "/",
  timeout: 60000,
});

axiosInstance.interceptors.request.use(
  (config) => {
    store.dispatch(startLoading());

    const token = store.getState().user?.token || localStorage.getItem("ACCESS_TOKEN");
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    store.dispatch(stopLoading());
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    store.dispatch(stopLoading());
    return response;
  },
  (error) => {
    store.dispatch(stopLoading());

    const status = error.response?.status;

    if (status === 401) {
      store.dispatch(resetUser());
      store.dispatch(logout());

      goLogin();

      return Promise.resolve(null);
    }


    return Promise.reject(error);
  }
);

export default axiosInstance;
